import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';
import { Injectable } from '@angular/core';

/**
 * Feature flag class to enable or disable the modification of admixtures.
 */
@Injectable()
export class ModifyActionBlkAdt implements IFlagFeature {
  name = Features.MODIFY_ACTION_BLK_ADT;

  public isEnabled(container: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
